import type { CategoryId } from "@/services/collection/categories";
import { fetchAllCategories, fetchCategoryById } from "@/services/collection/categories";
import { computedAsync } from "@vueuse/core";
import type { Ref } from "vue";

export function useMarketplaceItemCount(categoryId?: Ref<CategoryId | undefined>) {
  const count = computedAsync(async () => {
    const id = categoryId?.value;

    if (id === undefined) {
      const categories = await fetchAllCategories();
      return categories.reduce((acc, category) => acc + category.marketplaceItemsCount, 0);
    } else {
      const category = await fetchCategoryById(id);
      return category.marketplaceItemsCount;
    }
  }, 0);

  const countRounded = computedAsync(async () => {
    const c = await count.value;
    if (c < 100) {
      return c;
    }
    return Math.floor(c / 100) * 100;
  });

  return {
    count,
    countRounded,
  };
}
